import React, { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import LoadMask from "../../../../../Utils/LoadMask/LoadMask";
import { getErrorFromResponse } from "../../../../../../../utility/utils";
import { InventarioOtrosAcopiosApi } from "../api/InventarioOtrosAcopiosApi";
import { AnalisisSobranteConsulta } from "./AnalisisSobranteConsulta";
import { DatosAlmacenInventario } from "../../../components/Almacenes/DatosAlmacenInventario";
import { RecepcionesSobranteTable } from "../../../components/Almacenes/RecepcionesSobranteTable";
import { ResumenRecepcionesDRC } from "../../../components/Almacenes/ResumenRecepcionesDRC";

export const ConsultaSobranteAlmacen = ({
    inventarioAlmacenId,
    regresar,
    setNombreAlmacen,
}) => {
    const { getDetalleAlmacen, getAnalisisSobrante, cargando } =
        InventarioOtrosAcopiosApi();

    const [detalleAlmacen, setDetalleAlmacen] = useState({});
    const [recepciones, setRecepciones] = useState([]);
    const [analisis, setAnalisis] = useState(null);

    const GetSobranteAlmacen = async () => {
        try {
            const detalle = await getDetalleAlmacen(inventarioAlmacenId);

            setDetalleAlmacen(detalle);
            setRecepciones(detalle.recepciones || []);

            if (detalle.inventario_almacen) {
                setNombreAlmacen(detalle.inventario_almacen.nombre_almacen);
            }
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el sobrante del almacén",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setDetalleAlmacen({});
            setRecepciones([]);
        }

        try {
            const respuesta = await getAnalisisSobrante(inventarioAlmacenId);

            setAnalisis(
                respuesta && respuesta.exists ? respuesta.analisis : null,
            );
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el análisis de DRC del almacén",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setAnalisis(null);
        }
    };

    useEffect(() => {
        GetSobranteAlmacen();
    }, [inventarioAlmacenId]);

    const inventarioAlmacen = detalleAlmacen.inventario_almacen;

    return (
        <LoadMask loading={cargando} blur>
            <DatosAlmacenInventario datosAlmacen={inventarioAlmacen} />

            <AnalisisSobranteConsulta analisis={analisis} />

            <h4 className="mt-4 mb-3">Recepciones reportadas como sobrante</h4>
            <RecepcionesSobranteTable recepciones={recepciones} />

            <ResumenRecepcionesDRC
                datosAlmacen={inventarioAlmacen}
                movimientos={recepciones}
            />

            <div className="d-flex justify-content-center mt-4">
                <button className="btn btn-outline-dark" onClick={regresar}>
                    Regresar
                </button>
            </div>
        </LoadMask>
    );
};
